import { FishingReport, KitIntent, WaterbodyDetail } from '@omniafishing/core';
import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useResponsive } from '../../../../hooks/use_responsive';
import { WebAnalytics } from '../../../../lib/web_analytics';
import { getSeasonGroupBySeasonName } from '../../../../redux/reference_data';
import { RoutePaths } from '../../../../routes';
import { ContentWrapper } from '../../../content_wrapper/content_wrapper';
import { DynamicKitModal } from '../../../dynamic_kit/dynamic_kit_modal';
import { OmniaLinkButton } from '../../../omnia_button/omnia_link_button';
import SvgNewExpert from '../../../svg/new_expert';
import { useWaterbodyWebAnalyticsArgs } from '../../waterbody_detail_lib/use_waterbody_web_analytics_args';
import { RecentTrendingReportsCarousel } from './recent_trending_carousel';
import styles from './waterbody_detail_top_products.less';

interface WaterbodyDetailTopProductsProps {
  hotbaitFishingReports: FishingReport[];
  onTechniqueClick: () => void;
  waterbody: WaterbodyDetail;
}

export const WaterbodyDetailTopProducts = (props: WaterbodyDetailTopProductsProps) => {
  const { hotbaitFishingReports, onTechniqueClick, waterbody } = props;

  const [dynamicKitOpen, setDynamicKitOpen] = useState(false);
  const [dynamicKitFishingIntent, setDynamicKitFishingIntent] = useState<KitIntent>();
  const seasonGroupBySeasonName = useSelector(getSeasonGroupBySeasonName);
  const { isDesktop } = useResponsive();
  const webAnalyticsLakeClickArgs = useWaterbodyWebAnalyticsArgs(waterbody);

  if (hotbaitFishingReports.length <= 2) {
    return null;
  }

  const handleKitClick = (fishingReport: FishingReport) => {
    setDynamicKitFishingIntent({
      waterbody,
      technique: fishingReport.technique,
      species: fishingReport.species,
      season_group: seasonGroupBySeasonName(fishingReport.season.name),
      state: null,
      kit_products: [
        {
          product: fishingReport.featured_product,
          quantity: 1,
          active: true,
          id: fishingReport.featured_product.id,
        },
      ],
      id: fishingReport.id,
    });
    setDynamicKitOpen(true);
  };

  return (
    <ContentWrapper>
      <div className={styles.topProducts}>
        <div className={styles.headerContainer}>
          <div className={styles.header}>
            <h2 className={styles.heading}>Top Products</h2>
            <div className={styles.expertButtonContainer}>
              {isDesktop && (
                <OmniaLinkButton
                  to={RoutePaths.PERSONAL_SHOPPING}
                  onClick={() =>
                    WebAnalytics.lakePageClick('[products].(expert)', webAnalyticsLakeClickArgs)
                  }
                  kind="secondary"
                  size="lg"
                  fontSize={14}
                >
                  <span>
                    <SvgNewExpert fontSize={17} />
                  </span>
                  Talk to an Expert
                </OmniaLinkButton>
              )}
            </div>
          </div>
        </div>

        {hotbaitFishingReports.length > 2 && (
          <RecentTrendingReportsCarousel
            onKitClick={handleKitClick}
            onTechniqueClick={onTechniqueClick}
            hotbaitFishingReports={hotbaitFishingReports}
            waterbody={waterbody}
          />
        )}
      </div>
      {dynamicKitFishingIntent && (
        <DynamicKitModal
          open={dynamicKitOpen}
          onCancel={() => {
            setDynamicKitOpen(false);
          }}
          fishingIntent={dynamicKitFishingIntent}
        />
      )}
    </ContentWrapper>
  );
};
